import * as React from "react"
import {
  Box,
  Center,
  Container,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react"
import Head from "next/head"
import { HomeLayout } from "components/HomeLayout"
import { NFTCard } from "components/NFTCard"
import splitbee from "@splitbee/web"
import { CheckIcon } from "@chakra-ui/icons"
import { nfts } from "lib/data"
import { LinkButton } from "components/LinkButton"

// Splitbee.js
splitbee.track("NFTs")

export default function NFTs() {
  return (
    <Box>
      <Head>
        <title>ROAMpool NFTs</title>
      </Head>
      <HeroNFT />
      <Center>
        <Heading m={10} py={{ base: 5, md: 6 }}>
          What is this collection about?
        </Heading>
      </Center>
      <Center>
        <Text
          maxW={"3xl"}
          fontSize={"3xl"}
          fontFamily={"Caveat"}
          transform={"rotate(-1deg)"}
          m={20}
          align={"center"}
        >
          In the spirit of creating a ROAM future, and in order to commemorate such a historical human event,
          we worked to create our first art collection of our favorite roaming animal. The LLAMA!
        </Text>
      </Center>

      <Center>
        <Heading py={{ base: 10, md: 16 }} m={10}>
          Llama Collection
        </Heading>
      </Center>

      <Container maxW={"6xl"} mb={10} mt={10}>
        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={6}>
          {nftSellingPoints.map((feature, idx) => (
            <HStack key={idx} align={"top"}>
              <Box color={"green.400"} px={2}>
                <Icon as={CheckIcon} />
              </Box>
              <VStack align={"start"}>
                <Text fontSize="xl" fontWeight={600}>
                  {feature.title}
                </Text>
                <Text color={"gray.600"}>{feature.text}</Text>
              </VStack>
            </HStack>
          ))}
        </SimpleGrid>
      </Container>

      <Heading align={"center"} m={10} py={{ base: 10, md: 16 }}>
        SHOW ME THE LLAMAS!
      </Heading>
      <Text align={"center"}>
        We have 1000 unique roam llamas, with the 100 below as awards for delegators.
      </Text>
      <Center>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={{ base: 1, md: 2, lg: 4 }}>
          {nfts.map((nft) => (
            <NFTCard key={nft.id} nft={nft} />
          ))}
        </SimpleGrid>
      </Center>
    </Box>
  )
}

NFTs.getLayout = (page: React.ReactNode) => <HomeLayout>{page}</HomeLayout>

const nftSellingPoints = [
  {
    title: "Unique",
    text: "No two are alike!",
  },
  {
    title: "Custom Art NFTs",
    text: "Our artists created the art and we minted them as NFTs.",
  },
  {
    title: "Lifetime Ownership",
    text: "Once awarded, they're yours forever.",
  },
  {
    title: " Membership",
    text: "These Llamas have access to our ROAM membership.",
  },
  {
    title: "Buyback Guarantee",
    text: "Sell the NFT back to us for a guaranteed 100 ADA.",
  },
  {
    title: "Automatic Delivery",
    text: "The reward will automatically be air-dropped to your wallet.",
  },
]

export function HeroNFT() {
  return (
    <Container maxW={"3xl"} py={{ base: 20, md: 36 }}>
      <Stack as={Box} textAlign={"center"} spacing={{ base: 8, md: 14 }} py={{ base: 20, md: 36 }}>
        <Heading fontWeight={600} fontSize={{ base: "2xl", sm: "4xl", md: "6xl" }} lineHeight={"110%"}>
          <Text as={"span"} color={"green.400"}>
            ROAM
          </Text>
          Llama{" "}
          <Text as={"span"} color={"gray.500"}>
            NFTs
          </Text>
        </Heading>
        <Text color={"gray.500"}>A stake pool on the Cardano Blockchain that rewards NFT artwork</Text>
      </Stack>
    </Container>
  )
}
